import { DUPLEX_SERVICES } from '@bcm/constants';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const STAGES = {
	local: 'local',
	dev: 'dev',
	qa: 'qa',
	prod: 'prod',
	uaeProd: 'uaeProd',
};

export const NODE_ENVS = {
	local: 'local',
	production: 'production',
};

const LOCAL_URL = 'http://10.0.0.119';

export const REGIONS_BY_DOMAIN = {
	'http://localhost:19006': STAGES.local,
	[`${LOCAL_URL}:19006`]: STAGES.local,
	'https://devportal.burncammedical.com': STAGES.dev,
	'https://qaportal.burncammedical.com': STAGES.qa,
	'https://portal.burncammedical.com': STAGES.prod,
	'https://uae.burncammedical.com': STAGES.uaeProd,
};

export const DUPLEX_SERVICES_BY_STAGE = {
	local: DUPLEX_SERVICES.polling,
	dev: DUPLEX_SERVICES.websocket,
	qa: DUPLEX_SERVICES.websocket,
	prod: DUPLEX_SERVICES.websocket,
	uaeProd: DUPLEX_SERVICES.websocket,
};


export const DOMAINS = {
	local: `${LOCAL_URL}:19006`,
	website: 'https://burncammedical.com',
	dev: 'https://devportal.burncammedical.com',
	qa: 'https://qaportal.burncammedical.com',
	prod: 'https://portal.burncammedical.com',
	uaeProd: 'https://uae.burncammedical.com',
};
const WEBSOCKET_API_GATEWAYS = {
	local: 'wss://devws.burncammedical.com',
	dev: 'wss://devws.burncammedical.com',
	qa: 'wss://qaws.burncammedical.com',
	prod: 'wss://ws.burncammedical.com',
	uaeProd: 'wss://uaews.burncammedical.com',
};

// Use ipconfig and Ethernet adapter Ethernet
export const REST_API_GATEWAYS = {
	local: `${LOCAL_URL}:80`,
	dev: 'https://devapi.burncammedical.com',
	qa: 'https://qaapi.burncammedical.com',
	prod: 'https://api.burncammedical.com',
	uaeProd: 'https://uaeapi.burncammedical.com',
};

class Environment {
	constructor({
		STAGE,
		NODE_ENV,
		BE_NODE_ENV,
		DUPLEX_SERVICE,
	}) {
		this.STAGE = STAGE;
		this.DOMAIN = DOMAINS[STAGE];
		this.WEBSOCKET_API_GATEWAY = WEBSOCKET_API_GATEWAYS[STAGE];
		this.WEBSOCKET_REST_TIMEOUT = 10 * 1000;
		this.REST_API_GATEWAY = REST_API_GATEWAYS[STAGE];
		this.NODE_ENV = NODE_ENV;
		this.BE_NODE_ENV = BE_NODE_ENV;
		this.USER_INACTIVITY_TIMEOUT = 1000 * 60 * 10;
		this.PUBLIC_S3_URL = 'https://bcm-be-dev-s3publicbucket.s3.amazonaws.com';
		this.SUPPORT_URL = 'https://burncam-support.atlassian.net/servicedesk/customer/portal/1';
		this.DUPLEX_SERVICE = DUPLEX_SERVICE;
		this.GOOGLE_PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.burncammedical.frontend';
		this.APPLE_APPSTORE_URL = 'https://apps.apple.com/us/app/burncam/id6466211826';
	}

	async setStage(STAGE) {
		this.STAGE = STAGE;
		this.DOMAIN = DOMAINS[STAGE];
		this.WEBSOCKET_API_GATEWAY = WEBSOCKET_API_GATEWAYS[STAGE];
		this.REST_API_GATEWAY = REST_API_GATEWAYS[STAGE];
		this.DUPLEX_SERVICE = DUPLEX_SERVICES_BY_STAGE[STAGE];
		await AsyncStorage.setItem('STAGE', JSON.stringify(STAGE));
	}

	async setDuplexService (duplexService) {
		this.duplexService = duplexService;
	}
}

const env = new Environment({
	STAGE: STAGES.prod,
	NODE_ENV: NODE_ENVS.production,
	BE_NODE_ENV: NODE_ENVS.production,
	DUPLEX_SERVICE: DUPLEX_SERVICES.websocket,
});

export default env;